import { useParams, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { BrandingEditor } from "../Components/BrandingEditor"

// Route: /agency/workspaces/:workspaceId/branding
// Loaded from the AgencyDashboard workspace row → "Branding" button
export default function WorkspaceBranding() {
    const { workspaceId } = useParams()
    const navigate = useNavigate()
    const [workspaceName, setWorkspaceName] = useState("")

    // Try to get workspace name from AgencyDashboard state passed via location
    useEffect(() => {
        // If coming from agency dashboard with state
        const stored = sessionStorage.getItem(`ws_name_${workspaceId}`)
        if (stored) setWorkspaceName(stored)
    }, [workspaceId])

    return (
        <div className="lg:w-3/4 md:w-3/4 w-11/12 mx-auto py-8">
            <button
                onClick={() => navigate("/agency")}
                className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 mb-6 transition"
            >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
                Back to Agency
            </button>

            <BrandingEditor workspaceId={workspaceId} workspaceName={workspaceName} />
        </div>
    )
}
